import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { SelectField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { PaymentMethods } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { WithReservationId } from '@mews-commander/types';
import { useGetAvailablePaymentPlanPaymentMethodsSuspense } from '../../../tables/PaymentPlans/hooks';
import { CreatePaymentPlanFormField } from '../types';
import { CreatePaymentPlanFormValues } from '../schema';

export const CreatePaymentPlanPaymentMethodsField = ({ reservationId }: WithReservationId) => {
    const { setValue, getValues, getFieldState } = useFormContext<CreatePaymentPlanFormValues>();
    const availablePaymentPlanPaymentMethods = useGetAvailablePaymentPlanPaymentMethodsSuspense({
        reservationIds: [reservationId],
    });

    const selectedPaymentMethods = getValues(CreatePaymentPlanFormField.PaymentMethods) || [];
    const { isDirty } = getFieldState(CreatePaymentPlanFormField.PaymentMethods);
    const shouldSkipPaymentMethodReset =
        isDirty && selectedPaymentMethods.every((method) => availablePaymentPlanPaymentMethods.includes(method));

    useEffect(() => {
        if (shouldSkipPaymentMethodReset) {
            return;
        }

        setValue(CreatePaymentPlanFormField.PaymentMethods, availablePaymentPlanPaymentMethods);
    }, [availablePaymentPlanPaymentMethods, shouldSkipPaymentMethodReset, setValue]);

    const paymentMethodsOptions = [
        {
            value: PaymentMethods.SepaDirectDebit,
            label: lt('SEPADirectDebit'),
        },
        {
            value: PaymentMethods.PaymentCard,
            label: lt('GeneralCardPlural'),
        },
    ];

    const paymentMethodsSelectFieldOptions = paymentMethodsOptions
        .filter(({ value }) => availablePaymentPlanPaymentMethods.includes(value))
        .map(createOption);

    return (
        <SelectField
            name={CreatePaymentPlanFormField.PaymentMethods}
            label={lt('CreatePaymentPlanFormPaymentRequestMethodsLabel')}
            helper={lt('CreatePaymentPlanFormPaymentRequestMethodsHelper')}
            multiselect
            required
            options={paymentMethodsSelectFieldOptions}
        />
    );
};
